import { RECOVERY_FORM_TOKEN } from '@constants/placeholders';

const TOKEN_PATTERN = new RegExp(`\\[${RECOVERY_FORM_TOKEN}\\]`, 'gi');

const EXACT_TOKEN_PATTERN = new RegExp(`^\\[${RECOVERY_FORM_TOKEN}\\]$`, 'i');

export const resolveRecoveryFormToken = (text, url) => (text && url ? text.replace(TOKEN_PATTERN, url) : text);

const PLACEHOLDER_PATTERN = /\[[^[\]\n]+\]/g;

export const findUnresolvedPlaceholders = text => text?.match(PLACEHOLDER_PATTERN) || [];

export const isRecoveryFormToken = placeholder => EXACT_TOKEN_PATTERN.test(placeholder);
